import dispatcher from "./../Dispatcher/Dispatcher";
import config from "./../Config/Config";
import httpRequest from "../HttpRequests/HttpRequest";
import GraphDashboardContants from "./../Constants/GraphDashboardConstants";

class GraphDashboardActions {
  // getDashboardGraphs(WerkId) {
  //   httpRequest(
  //     config.webServiceURL + "/Dashboard/Gets/" + WerkId,
  //     "GET",
  //     null,
  //     (res, message) => {
  //       if (res !== "Error") {
  //         dispatcher.dispatch({
  //           type: GraphDashboardContants.GET_DASHBOARD_GRAPH_SUCCESS,
  //           result: res,
  //         });
  //       } else {
  //         dispatcher.dispatch({
  //           type: GraphDashboardContants.GET_DASHBOARD_GRAPH_FAILURE,
  //           result: message,
  //         });
  //       }
  //     }
  //   );
  // }

  getDashboardEquipmentStatusDistribution(_payLoad) {
    httpRequest(
      config.webServiceURL + "/Dashboard/GetEquipmentKPIData",
      "POST",
      JSON.stringify({
        ..._payLoad,
      }),
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: GraphDashboardContants.GET_DASHBOARD_GRAPH_EQUIPMENTSTATUS_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: GraphDashboardContants.GET_DASHBOARD_GRAPH_EQUIPMENTSTATUS_FAILURE,
            result: message,
          });
        }
      }
    );
  }

  getInspectionKpiDat(_payLoad) {
    httpRequest(
      config.webServiceURL + "/Dashboard/GetInspectinonKPIData",
      "POST",
      JSON.stringify({
        ..._payLoad,
      }),
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: GraphDashboardContants.GET_INSPECTION_KPI_DATA_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: GraphDashboardContants.GET_INSPECTION_KPI_DATA_FAILURE,
            result: message,
          });
        }
      }
    );
  }

  getTicketKpiData(_payLoad) {
    httpRequest(
      config.webServiceURL + "/Dashboard/GetTicketKPIData",
      "POST",
      JSON.stringify({
        ..._payLoad,
      }),
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: GraphDashboardContants.GET_TICKET_KPI_DATA_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: GraphDashboardContants.GET_TICKET_KPI_DATA_FAILURE,
            result: message,
          });
        }
      }
    );
  }

  getEqupipmentTicketCountKPIData(_payLoad) {
    httpRequest(
      config.webServiceURL + "/Dashboard/GetTicketEqupipmentKPIData",
      "POST",
      JSON.stringify({
        ..._payLoad,
      }),
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: GraphDashboardContants.GET_EQUIPMENT_TICKET_KPI_DATA_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: GraphDashboardContants.GET_EQUIPMENT_TICKET_KPI_DATA_FAILURE,
            result: message,
          });
        }
      }
    );
  }

  getOrganisationKpiData(_payLoad) {
    httpRequest(
      config.webServiceURL + "/Dashboard/GetOrganizationKPIData",
      "POST",
      JSON.stringify({
        ..._payLoad,
      }),
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: GraphDashboardContants.GET_ORG_KPI_DATA_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: GraphDashboardContants.GET_ORG_KPI_DATA_FAILURE,
            result: message,
          });
        }
      }
    );
  }

  getDashboardSummaryData(_payLoad) {
    httpRequest(
      config.webServiceURL + "/Dashboard/GetDashboardSummary",
      "POST",
      JSON.stringify({
        ..._payLoad,
      }),
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: GraphDashboardContants.GET_DASHBOARD_SUMMARY_DATA_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: GraphDashboardContants.GET_DASHBOARD_SUMMARY_DATA_FAILURE,
            result: message,
          });
        }
      }
    );
  }
}
export default new GraphDashboardActions();
